export const numberFormater = num => {
  return num?.toLocaleString();
};